import { render, staticRenderFns } from "./stripeCheckout.vue?vue&type=template&id=37bd172f&"
import script from "./stripeCheckout.vue?vue&type=script&lang=js&"
export * from "./stripeCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports